import { Alert, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ClaudeCodeLoginGate from '@/components/claude-code/ClaudeCodeLoginGate';
import { getConfig } from '@/config';
import { ROUTES } from '@/routes/routes';
import McpAccessContent from './McpAccessContent';
import StaffSessionRequired from './StaffSessionRequired';
import { useMcpKeyAdministration } from './useMcpKeyAdministration';

/** The manage pages are shown only to people the Facade says may manage others, nothing while it is asked. */
const ManageOthersLink = () => {
  const { data } = useMcpKeyAdministration();
  if (!data?.canManageOthersKeys) {
    return null;
  }
  return (
    <div className="d-flex justify-content-end gap-2 mb-3">
      <Link to={ROUTES.mcpAccess.people} className="btn btn-outline-primary btn-sm">
        Manage people and keys
      </Link>
    </div>
  );
};

/** Self-service MCP keys, behind the staff sign-in. HR managers and admins also get a way to other people's keys. */
const McpAccessPage = () => (
  <Container className="py-4">
    <ClaudeCodeLoginGate>
      {(session) =>
        getConfig().logtoAppId ? (
          <StaffSessionRequired email={session.email}>
            <ManageOthersLink />
            <McpAccessContent />
          </StaffSessionRequired>
        ) : (
          <Alert variant="secondary">MCP keys are not available on this stage: it has no staff sign-in.</Alert>
        )
      }
    </ClaudeCodeLoginGate>
  </Container>
);

export default McpAccessPage;
